import { useSelector } from "react-redux";
import { authSelectors } from "../store/auth/selector";
import { apiEndpoint } from "../utils/endpoints";

import { useAuth } from "@clerk/clerk-react";
import { GraphQLClient } from "graphql-request";
import { RequestMiddleware } from "graphql-request/build/esm/types";
import { useParams } from "react-router-dom";

export default function useGqlClient() {
  const { dealId: activeDealId } = useParams<{ dealId: string }>();
  const actor = useSelector(authSelectors.actor);
  const { getToken } = useAuth();

  const requestMiddleware: RequestMiddleware = async (request) => {
    const token = await getToken({ template: "longer_session" });

    if (!token) {
      return request;
    }

    return {
      ...request,
      headers: {
        ...request.headers,
        authorization: `Bearer ${token}`,
        "x-deal-id": activeDealId ?? "",
        "x-actor-id": actor?.account.id ?? "",
      },
    };
  };

  const client = new GraphQLClient(apiEndpoint(), { requestMiddleware });

  return client;
}
